<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.3889 5.63889C10.9747 5.63889 10.6389 5.97467 10.6389 6.38889V13.6111C10.6389 14.0253 10.9747 14.3611 11.3889 14.3611H14.7222C15.1365 14.3611 15.4722 14.0253 15.4722 13.6111V6.38889C15.4722 5.97467 15.1365 5.63889 14.7222 5.63889H11.3889ZM12.1389 12.8611V7.13889H13.9722V12.8611H12.1389Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.16668 2.30554C2.52517 2.30554 1.19446 3.63625 1.19446 5.27776V14.7222C1.19446 16.3637 2.52517 17.6944 4.16668 17.6944H15.8333C17.4749 17.6944 18.8056 16.3637 18.8056 14.7222V5.27776C18.8056 3.63625 17.4749 2.30554 15.8333 2.30554H4.16668ZM2.69446 5.27776C2.69446 4.46468 3.35359 3.80554 4.16668 3.80554H15.8333C16.6464 3.80554 17.3056 4.46468 17.3056 5.27776V14.7222C17.3056 15.5353 16.6464 16.1944 15.8333 16.1944H4.16668C3.35359 16.1944 2.69446 15.5353 2.69446 14.7222V5.27776Z"
            fill="currentColor"
        />
    </svg>
</template>
